import { Observable } from "rxjs";
import { createActionDuck } from "../helpers/action";
import createItemFetcher from "../helpers/item";
import { createNotificationOnCreateEpic, createNotificationOnCreateErrorEpic, createNotificationOnDeleteEpic, createNotificationOnDeleteErrorEpic } from "../modes/updateNotification";
function updateProgramOnModeUpdate(ActionKeys) {
    return actions$ => actions$.ofType(ActionKeys.FINISH).mergeMap(action => Observable.of(modeFocus.actions.fetchItem({
        scenario: action.config.scenario,
        program: action.config.program,
        workspace: action.config.workspace
    })));
}
export const computeModeFocus = (config) => {
    let { scenario, workspace, program } = config;
    return `/api/v1/modes/${scenario}/${workspace}/${program}`;
};
export function computeItemId(config) {
    const { scenario, workspace, program } = config;
    return `${scenario}_${workspace}_${program}`;
}
export const modeFocus = createItemFetcher(computeModeFocus, "MODEFOCUS", computeItemId);
export function createModeFocus() {
    return modeFocus;
}
const computeCreateModeUrl = (program) => {
    const mode = program.mode
        ? "mode=" + program.mode + "&newMode=" + program.newMode
        : "newMode=" + program.newMode;
    return {
        url: `/api/v1/modes/${program.scenario}/${program.workspace}/${program.program}/copyAs?` + mode,
        method: "POST"
    };
};
export const copyFocusMode = createActionDuck("ModeFocusCreate", computeCreateModeUrl, computeItemId);
export const copyModeFunction = (program, from, newMode) => {
    return copyFocusMode.actions.start(Object.assign(Object.assign({}, program), { mode: from, newMode: newMode }), {});
};
copyFocusMode.middleware.push(createNotificationOnCreateEpic(copyFocusMode.ActionKeys), createNotificationOnCreateErrorEpic(copyFocusMode.ActionKeys), updateProgramOnModeUpdate(copyFocusMode.ActionKeys));
const computeDeleteModeUrl = (config) => ({
    url: `/api/v1/modes/${config.scenario}/${config.workspace}/${config.program}/${config.mode}`,
    method: "DELETE"
});
export const deleteFocusMode = createActionDuck("ModeFocusDelete", computeDeleteModeUrl, computeItemId);
deleteFocusMode.middleware.push(createNotificationOnDeleteEpic(deleteFocusMode.ActionKeys), createNotificationOnDeleteErrorEpic(deleteFocusMode.ActionKeys), updateProgramOnModeUpdate(deleteFocusMode.ActionKeys));
//# sourceMappingURL=index.js.map